import { Currency } from '@/core/currency/interfaces';

const SVC: Currency = {
    name: 'Salvadoran Colón',
    demonym: 'Salvadoran',
    majorSingle: 'Colón',
    majorPlural: 'Colones',
    codeNumeric: '222',
    symbol: '₡',
    symbolNative: '₡',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'SVC',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default SVC;
